module.exports = __webpack_public_path__ + "img/instituto-morrodosanjos.b83cd6c9.png";